/**
 * Normalizes the error thrown by the Orval fetcher into the payload shape the member
 * reducer's error cases expect.
 *
 * The fetcher rejects with an AppError ({ status, code, message, details, ... }). The QuickMD
 * API error body (ErrorCode / Data / UserFriendlyErrorCode) lives on `details`, which is the
 * exact shape the member reducer's `*_ERROR` cases read. When `details` is unavailable the
 * raw error is returned so the reducer falls back to its default message handling.
 */
export function getMemberApiErrorPayload(error: unknown): unknown {
  if (error && typeof error === 'object' && 'details' in error && error.details) {
    return error.details
  }
  return error
}
